<body>
<p>This page doesnt exist</p>
<a href="#">Home</a>
</body>